import { useState, useEffect } from 'react'
import { differenceInSeconds } from 'date-fns'

interface UseWrittenTimerProps {
  auto_reply_at?: Date | null
  publication_at?: Date | null
}

export const useWrittenTimer = ({ auto_reply_at, publication_at }: UseWrittenTimerProps) => {
  const [timeLeft, setTimeLeft] = useState<string>('')

  useEffect(() => {
    // If there's no auto-reply time or the message is already published, don't show timer
    if (!auto_reply_at || publication_at) {
      setTimeLeft('')
      return
    }

    const updateTimer = () => {
      const now = new Date()
      const expiresAt = new Date(auto_reply_at)
      const diffInSeconds = differenceInSeconds(expiresAt, now)

      if (diffInSeconds <= 0) {
        setTimeLeft('00:00')
        return
      }

      const minutes = Math.floor(diffInSeconds / 60)
      const seconds = diffInSeconds % 60
      setTimeLeft(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`)
    }

    // Update immediately
    updateTimer()

    // Update every second
    const interval = setInterval(updateTimer, 1000)

    return () => clearInterval(interval)
  }, [auto_reply_at, publication_at])

  return { timeLeft }
}